import type { ComponentChildren } from 'preact';
import { SiteNav } from './SiteNav';
import { Footer, type FooterTone } from './Footer';
import type { Region } from '../hooks/useRegion';

interface LayoutProps {
  children: ComponentChildren;
  region: Region;
  onRegionChange: (region: Region) => void;
  hideFooter?: boolean;
  hideHeader?: boolean;
  darkNav?: boolean;
  navTone?: 'green' | 'sage' | 'brown';
  footerTone?: FooterTone;
}

export function Layout({ children, region, onRegionChange, hideFooter, hideHeader, darkNav, navTone, footerTone }: LayoutProps) {
  return (
    <div class="app">
      {!hideHeader && <SiteNav dark={darkNav} tone={navTone} region={region} onRegionChange={onRegionChange} />}
      <main id="main-content" class="main">
        {children}
      </main>
      {!hideFooter && <Footer tone={footerTone} />}
    </div>
  );
}
